import { Spinner } from 'flowbite-react'
import React from 'react'

export default function LoadingPage() {
  return (
    <div className="flex flex-row min-w-screen min-h-screen dark:bg-gray-900">
        <div className="flex">
            <Spinner/>
            <p className='text-gray-600 dark:text-gray-300'>Loading...</p>
        </div>
        
    </div>
  )
}
